import {ICapture, ICaptureConfig, IDeleteCaptureResponse, IGetCapturesResponse, IPostCaptureResponse} from "interfaces";
import {axiosAPI} from "./API";
import { TaskState } from "enums";

// Singleton for interacting with Captures
class _CaptureService {

    public allCaptures: ICapture[] = [];

    public getAll = (): Promise<IGetCapturesResponse> => {

        return axiosAPI.get<IGetCapturesResponse>("/capture")
            .then((resp) => {
                let capturesResponse = resp.data;
                // save to cache
                this.allCaptures = capturesResponse.data;
                // filter deleted
                this.allCaptures = this.allCaptures.filter(c => c.status != TaskState.Deleted);
                // sort
                this.allCaptures.sort((a, b) => {
                    // special cases to make sure running/pending tasks go to the top
                    // since they have a start time of 0 but we want to sort descending
                    if (a.startTime == 0) return -1;
                    if (b.startTime == 0) return 1;
                    return b.startTime - a.startTime;
                })
                return capturesResponse;
            })
            .catch((err) => {
                console.error("Error getting all captures: ", err);
                throw err;
            });
    }

    public postCapture = (name: string, config: ICaptureConfig): Promise<IPostCaptureResponse> => {

        let data = {
            'captureName': name,
            'captureConfigUUID': config.captureConfigUUID,
        };

        return axiosAPI.post<IPostCaptureResponse>('/capture', data)
            .then((resp) => {
                let newCapture: ICapture = {
                    name: name,
                    captureUUID: resp.data.data.captureUUID,
                    configUUID: config.captureConfigUUID,
                    status: TaskState.Pending,
                    startTime: 0,
                    endTime: 0,
                    messageCount: 0,
                    messageTTL: 0,
                };
                // save to cache
                this.allCaptures.unshift(newCapture);
                return resp.data;
            })
            .catch((err) => {
                console.error("Error posting capture: ", err);
                throw err;
            });
    }

    public deleteCapture = (capture: ICapture): Promise<IDeleteCaptureResponse> => {

        let url = `/capture/${capture.captureUUID}`;
        if (capture.status === TaskState.Success || capture.status === TaskState.Cancelled) url += "?delete=true";

        return axiosAPI.delete<IDeleteCaptureResponse>(url)
            .then((resp) => {
                if (resp.data.data.status === TaskState.Deleted) {
                    // remove from list
                    this.allCaptures = this.allCaptures.filter(c => c.captureUUID != capture.captureUUID);
                    // OR change item status
                    // this.allCaptures[this.allCaptures.findIndex(c => c.captureUUID === capture.captureUUID)].status = TaskState.Deleted;
                }
                if (resp.data.data.status === TaskState.Cancelled) {
                    this.allCaptures[this.allCaptures.findIndex(c => c.captureUUID === capture.captureUUID)].status = TaskState.Cancelled;
                }
                return resp.data;
            })
            .catch((err) => {
                console.error("Error deleting capture: ", err);
                throw err;
            });
    }
}

export const CaptureService = new _CaptureService();